module.exports = __webpack_public_path__ + "img/video.78a622d0.jpg";